import React, { Component } from 'react';
import Search from './searchform';
import Navigation from './navigation';

export default class Header extends Component {
  render() {
    return (
      <header>
        <Navigation />
        {this.props.showSearch ? <Search narrow={this.props.narrow} /> : null}
      </header>
    );
  }
}
